"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeScreenComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const Prism = __importStar(require("./inc/prism"));
require("./preview/component");
const events_1 = require("../../event/events");
const voucher_code_generator_1 = __importDefault(require("voucher-code-generator"));
const ClipboardService_1 = __importStar(require("../../services/ClipboardService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="code-viewer ${x => x.isFullscreen ? 'fullscreen' : ''} ${x => x.isPopupMode ? 'popup-mode' : ''}${x => x.showTime ? ' show-time' : ''}" ${(0, fast_element_1.ref)('codeViewer')}>
    
    <slot style="display: none;"></slot>
    
    ${T.when(x => x.loading, T.html `
        <div class="loading-container">
            <div class="loading-spinner"></div>
            <span class="loading-text">Rendering markdown...</span>
        </div>
    `)}
    
    ${T.when(x => x.error, T.html `
        <div class="error-container">
            <div class="error-icon">⚠️</div>
            <div class="error-message">${x => x.error}</div>
            <button class="retry-button" @click="${x => x.refresh()}">
                <i class="simple-icon-refresh"></i>
                Retry
            </button>
        </div>
    `)}
    
    ${T.when(x => !x.loading && !x.error && x.renderedContent, T.html `       
        <div class="code-block-wrapper">
            <div class="code-header">
                <span class="code-lang">${x => x.lang}</span>
                
                ${T.when(x => !x.autoScrollEnabled && x.codeGenerating, T.html `
                    <button class="auto-scroll-button" 
                            @click="${x => x.enableAutoScroll()}" 
                            title="Re-enable auto-scroll to follow new content">
                        <i class="simple-icon-arrow-down"></i>
                        Auto-scroll
                    </button>
                `)}
                
                    <div class="code-actions">
                        <button class="action-btn copy-btn ${x => x.copied ? 'is-copied' : ''}" 
                                @click="${x => x.copyToClipboard()}" 
                                title="Copy to clipboard">
                            ${T.when(x => x.copied, T.html `<i class="simple-icon-check"></i>`, T.html `<i class="simple-icon-docs"></i>`)}
                        </button>
                        
                        ${T.when(x => x.showPreview, T.html `
                            <div class="view-toggle-group">
                                <button class="toggle-btn ${x => x.previewVisible ? 'active' : ''}" 
                                        @click="${x => x.isPreviewToggleAvailable() ? x.togglePreview() : null}" 
                                        :disabled="${x => x.codeGenerating}"
                                        title="${x => x.codeGenerating ? 'Preview disabled during code generation' : 'Show preview'}">
                                    <i class="simple-icon-eye"></i>
                                </button>
                                <button class="toggle-btn ${x => !x.previewVisible ? 'active' : ''}" 
                                        @click="${x => x.previewVisible ? x.togglePreview() : null}" 
                                        :disabled="${x => x.codeGenerating}"
                                        title="Show code">
                                    <i class="simple-icon-screen-desktop"></i>
                                </button>
                            </div>
                        `)}
                        
                        <button class="action-btn close-btn" 
                                @click="${x => x.close()}" 
                                title="Close">
                            <i class="simple-icon-close"></i>
                        </button>
                                        
                    <div class="dropdown-container">
                        <button class="action-btn dropdown-trigger" 
                                @click="${x => x.toggleDropdown()}"
                                title="More options">
                            <i class="simple-icon-options"></i>
                        </button>
                        <div class="dropdown-menu ${x => x.dropdownOpen ? 'show' : ''}">
                            <button class="dropdown-item" 
                                    @click="${x => { x.togglePopup(); x.dropdownOpen = false; }}"
                                    title="${x => x.isPopupMode ? 'Close popup' : 'Open in popup'}">
                                <i class="simple-icon-${x => x.isPopupMode ? 'close' : 'frame'}"></i>
                                <span>${x => x.isPopupMode ? 'Close popup' : 'Open in popup'}</span>
                            </button>
                            <button class="dropdown-item" 
                                    @click="${x => { x.toggleFullscreen(); x.dropdownOpen = false; }}"
                                    title="${x => x.isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}">
                                <i class="simple-icon-size-${x => x.isFullscreen ? 'actual' : 'fullscreen'}"></i>
                                <span>${x => x.isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            ${T.when(x => !x.previewVisible, T.html `
                <div class="markdown-content" ${(0, fast_element_1.ref)('scrollContainer')} :innerHTML="${x => x.renderedContent}"></div>
            `)}

            ${T.when(x => x.showPreview && x.previewVisible, T.html `
                <div class="preview-section">
                    <html-preview :htmlContent="${x => x.htmlContentForPreview}" :componentId="${x => x.componentId}">
                    </html-preview>
                </div>
            `)}
        </div>
           
    `)}
    
    ${T.when(x => !x.loading && !x.error && !x.renderedContent, T.html `
        <div class="empty-state">
            <div class="empty-icon">📄</div>
            <div class="empty-message">No markdown content provided</div>
        </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `code[class*=language-], pre[class*=language-] {
  color: #000;
  background: 0 0;
  text-shadow: 0 1px #fff;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

code[class*=language-] ::-moz-selection, code[class*=language-]::-moz-selection, pre[class*=language-] ::-moz-selection, pre[class*=language-]::-moz-selection {
  text-shadow: none;
  background: #b3d4fc;
}

code[class*=language-] ::selection, code[class*=language-]::selection, pre[class*=language-] ::selection, pre[class*=language-]::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-], pre[class*=language-] {
    text-shadow: none;
  }
}
pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}

:not(pre) > code[class*=language-], pre[class*=language-] {
  background: #f5f2f0;
}

:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.cdata, .token.comment, .token.doctype, .token.prolog {
  color: #708090;
}

.token.punctuation {
  color: #999;
}

.token.namespace {
  opacity: 0.7;
}

.token.boolean, .token.constant, .token.deleted, .token.number, .token.property, .token.symbol, .token.tag {
  color: #905;
}

.token.attr-name, .token.builtin, .token.char, .token.inserted, .token.selector, .token.string {
  color: #690;
}

.language-css .token.string, .style .token.string, .token.entity, .token.operator, .token.url {
  color: #9a6e3a;
  background: hsla(0, 0%, 100%, 0.5);
}

.token.atrule, .token.attr-value, .token.keyword {
  color: #07a;
}

.token.class-name, .token.function {
  color: #dd4a68;
}

.token.important, .token.regex, .token.variable {
  color: #e90;
}

.token.bold, .token.important {
  font-weight: 700;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

pre[class*=language-].line-numbers {
  position: relative;
  padding-left: 3.8em;
  counter-reset: linenumber;
}

pre[class*=language-].line-numbers > code {
  position: relative;
  white-space: inherit;
}

.line-numbers .line-numbers-rows {
  position: absolute;
  pointer-events: none;
  top: 0;
  font-size: 100%;
  left: -3.8em;
  width: 3em;
  letter-spacing: -1px;
  border-right: 1px solid #999;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.line-numbers-rows > span {
  display: block;
  counter-increment: linenumber;
}

.line-numbers-rows > span:before {
  content: counter(linenumber);
  color: #999;
  display: block;
  padding-right: 0.8em;
  text-align: right;
}

:host {
  display: block;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

:host(.share-preview) {
  margin: 1rem 0;
  height: auto;
  max-height: 700px;
}

.code-viewer {
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  font-family: var(--font-family, "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  transition: all 0.2s ease;
}
.code-viewer:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);
}
.code-viewer.fullscreen, .code-viewer:fullscreen, .code-viewer:-webkit-full-screen, .code-viewer:-moz-full-screen, .code-viewer:-ms-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  overflow: hidden;
}
.code-viewer.fullscreen .code-block-wrapper, .code-viewer:fullscreen .code-block-wrapper, .code-viewer:-webkit-full-screen .code-block-wrapper, .code-viewer:-moz-full-screen .code-block-wrapper, .code-viewer:-ms-fullscreen .code-block-wrapper {
  height: 100vh;
  max-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
}
.code-viewer.fullscreen .markdown-content, .code-viewer:fullscreen .markdown-content, .code-viewer:-webkit-full-screen .markdown-content, .code-viewer:-moz-full-screen .markdown-content, .code-viewer:-ms-fullscreen .markdown-content {
  max-height: 100vh;
  flex: 1;
  overflow-y: auto;
  padding-top: 40px;
}
.code-viewer.popup-mode {
  position: fixed;
  top: 58%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 1200px;
  max-height: 75vh;
  z-index: 90000;
  background: var(--background-color, #ffffff);
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1);
}
.code-viewer.popup-mode::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: -1;
  backdrop-filter: blur(8px);
  transition: backdrop-filter 0.3s ease;
}
.code-viewer .code-block-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  max-height: 100%;
}
.code-viewer .code-block-wrapper .markdown-content {
  flex: 1;
  overflow: auto;
  min-height: 0;
}
.code-viewer .code-block-wrapper .markdown-content pre {
  margin: 0;
  padding: 3rem 1.5rem 1.5rem;
  overflow-x: auto;
  font-size: 0.95rem;
  line-height: 1.5;
}
.code-viewer .code-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px;
}
.code-viewer .code-header .code-lang {
  margin: 4px 0px;
  background: linear-gradient(135deg, var(--primary-color, #73236B), var(--primary-color-light, #8b2f7a));
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  font-size: 0.75rem;
  z-index: 5;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.code-viewer .code-header .code-actions {
  display: inline-flex;
  gap: 0.5rem;
  z-index: 10;
  align-items: center;
}
.code-viewer .code-header .code-actions .action-btn,
.code-viewer .code-header .code-actions .copy-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--primary-color, #73236B);
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(8px);
}
.code-viewer .code-header .code-actions .action-btn:hover,
.code-viewer .code-header .code-actions .copy-btn:hover {
  background: var(--primary-color, #73236B);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.code-viewer .code-header .code-actions .action-btn.active, .code-viewer .code-header .code-actions .action-btn.is-copied,
.code-viewer .code-header .code-actions .copy-btn.active,
.code-viewer .code-header .code-actions .copy-btn.is-copied {
  background: var(--primary-color-lighter, #9d3489);
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.code-viewer .code-header .code-actions .action-btn.disabled,
.code-viewer .code-header .code-actions .copy-btn.disabled {
  background: rgba(255, 255, 255, 0.5);
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}
.code-viewer .code-header .code-actions .view-toggle-group {
  display: flex;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 3px;
  gap: 2px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
}
.code-viewer .code-header .code-actions .view-toggle-group .toggle-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 5px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.code-viewer .code-header .code-actions .view-toggle-group .toggle-btn:hover {
  background: rgba(var(--primary-color, #73236B), 0.1);
  color: var(--primary-color, #73236B);
  transform: none;
  box-shadow: none;
}
.code-viewer .code-header .code-actions .view-toggle-group .toggle-btn.active {
  background: var(--primary-color, #73236B);
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.code-viewer .code-header .code-actions .view-toggle-group .toggle-btn:disabled {
  background: transparent;
  color: #ccc;
  cursor: not-allowed;
  opacity: 0.5;
}
.code-viewer .code-header .code-actions .dropdown-container {
  position: relative;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  transform: translateX(-100%);
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-100%) translateY(-10px);
  transition: all 0.2s ease;
  z-index: 100;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: visible;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(-100%) translateY(0);
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item {
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background 0.2s ease;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item:first-child {
  border-radius: 7px 7px 0 0;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item:last-child {
  border-radius: 0 0 7px 7px;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item:only-child {
  border-radius: 7px;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item:hover {
  background: #f8f9fa;
  color: var(--primary-color, #73236B);
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item i {
  font-size: 12px;
  width: 14px;
  flex-shrink: 0;
}
.code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item span {
  font-weight: 500;
}
.code-viewer .preview-section {
  margin: 1rem 1.5rem 1.5rem;
  border: 1px solid var(--border-color, #e8e8e8);
  border-radius: 12px;
  overflow: hidden;
  flex: 1;
  background: #fff;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
}
.code-viewer .preview-section .preview-title {
  padding: 1rem 1.25rem;
  background: linear-gradient(to right, var(--section-background, #f8f9fa), rgba(248, 249, 250, 0.5));
  border-bottom: 1px solid var(--border-color, #e8e8e8);
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}
.code-viewer .preview-section html-preview {
  flex: 1;
  overflow: hidden;
}
.code-viewer .markdown-content::-webkit-scrollbar,
.code-viewer .preview-section::-webkit-scrollbar {
  width: 6px;
}
.code-viewer .markdown-content::-webkit-scrollbar-track,
.code-viewer .preview-section::-webkit-scrollbar-track {
  background: transparent;
}
.code-viewer .markdown-content::-webkit-scrollbar-thumb,
.code-viewer .preview-section::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  transition: background 0.2s ease;
}
.code-viewer .markdown-content::-webkit-scrollbar-thumb:hover,
.code-viewer .preview-section::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}
@media (max-width: 1024px) {
  .code-viewer {
    max-height: 85vh;
    border-radius: 14px;
  }
  .code-viewer.popup-mode {
    width: 95vw;
    max-height: 80vh;
    border-radius: 18px;
  }
  .code-viewer .code-block-wrapper {
    margin: 1.25rem;
    flex: 1;
    border-radius: 10px;
  }
}
@media (max-width: 768px) {
  .code-viewer {
    max-height: 90vh;
    border-radius: 12px;
  }
  .code-viewer.popup-mode {
    width: 98vw;
    max-height: 95vh;
    border-radius: 16px;
  }
  .code-viewer.popup-mode::before {
    backdrop-filter: blur(6px);
  }
  .code-viewer .code-block-wrapper {
    margin: 1rem;
    flex: 1;
    border-radius: 8px;
  }
  .code-viewer .code-block-wrapper .code-lang {
    font-size: 0.65rem;
    padding: 0.3rem 0.6rem;
    top: 0.6rem;
    left: 0.6rem;
    border-radius: 6px;
  }
  .code-viewer .code-block-wrapper .markdown-content pre {
    font-size: 0.9rem;
    padding: 2.5rem 1.2rem 1.2rem;
  }
  .code-viewer .code-header .code-actions {
    top: 0.6rem;
    right: 0.6rem;
    gap: 0.4rem;
  }
  .code-viewer .code-header .code-actions .action-btn,
  .code-viewer .code-header .code-actions .copy-btn {
    width: 28px;
    height: 28px;
    border-radius: 6px;
  }
  .code-viewer .code-header .code-actions .view-toggle-group {
    padding: 2px;
    border-radius: 6px;
  }
  .code-viewer .code-header .code-actions .view-toggle-group .toggle-btn {
    width: 26px;
    height: 26px;
    border-radius: 4px;
    color: #555;
  }
  .code-viewer .code-header .code-actions .dropdown-container .dropdown-menu {
    min-width: 140px;
    left: 0;
    transform: translateX(-100%) translateY(-10px);
  }
  .code-viewer .code-header .code-actions .dropdown-container .dropdown-menu.show {
    transform: translateX(-100%) translateY(0);
  }
  .code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item {
    padding: 8px 10px;
    font-size: 12px;
  }
  .code-viewer .code-header .code-actions .dropdown-container .dropdown-menu .dropdown-item i {
    font-size: 11px;
  }
  .code-viewer .preview-section {
    flex: 1;
    margin: 0.75rem 1rem 1rem;
    border-radius: 10px;
  }
  .code-viewer .preview-section .preview-title {
    padding: 0.8rem 1rem;
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .code-viewer {
    max-height: 95vh;
    border-radius: 8px;
  }
  .code-viewer.popup-mode {
    width: 100vw;
    max-height: 100vh;
    border-radius: 0;
    top: 0;
    left: 0;
    transform: none;
    position: fixed;
  }
  .code-viewer .code-block-wrapper {
    margin: 0.75rem;
    flex: 1;
    border-radius: 6px;
  }
  .code-viewer .code-block-wrapper .code-lang {
    font-size: 0.6rem;
    padding: 0.25rem 0.5rem;
    top: 0.5rem;
    left: 0.5rem;
  }
  .code-viewer .code-block-wrapper .markdown-content {
    padding-top: 0.8rem;
  }
  .code-viewer .code-block-wrapper .markdown-content pre {
    font-size: 0.85rem;
    padding: 2.2rem 1rem 1rem;
  }
  .code-viewer .code-actions {
    top: 0.5rem;
    right: 0.5rem;
    gap: 0.3rem;
  }
  .code-viewer .code-actions .action-btn,
  .code-viewer .code-actions .copy-btn {
    width: 26px;
    height: 26px;
    border-radius: 5px;
  }
  .code-viewer .code-actions .action-btn:hover,
  .code-viewer .code-actions .copy-btn:hover {
    transform: translateY(-0.5px);
  }
  .code-viewer .code-actions .view-toggle-group .toggle-btn {
    width: 24px;
    height: 24px;
  }
  .code-viewer .code-actions .dropdown-menu {
    min-width: 120px;
    left: 0;
    transform: translateX(-100%) translateY(-10px);
  }
  .code-viewer .code-actions .dropdown-menu.show {
    transform: translateX(-100%) translateY(0);
  }
  .code-viewer .code-actions .dropdown-menu .dropdown-item {
    padding: 6px 8px;
    font-size: 11px;
    gap: 8px;
  }
  .code-viewer .preview-section {
    flex: 1;
    margin: 0.5rem 0.75rem 0.75rem;
    border-radius: 8px;
  }
  .code-viewer .preview-section .preview-title {
    padding: 0.6rem 0.8rem;
    font-size: 0.8rem;
  }
  .code-viewer .markdown-content::-webkit-scrollbar,
  .code-viewer .preview-section::-webkit-scrollbar {
    width: 4px;
  }
}
@media (max-width: 320px) {
  .code-viewer .code-block-wrapper {
    margin: 0.5rem;
    flex: 1;
  }
  .code-viewer .code-block-wrapper .markdown-content pre {
    font-size: 0.8rem;
    padding: 2rem 0.8rem 0.8rem;
  }
  .code-viewer .code-actions .action-btn,
  .code-viewer .code-actions .copy-btn {
    width: 24px;
    height: 24px;
  }
  .code-viewer .preview-section {
    margin: 0.4rem 0.5rem 0.5rem;
  }
  .code-viewer .preview-section .preview-title {
    font-size: 0.75rem;
    padding: 0.5rem 0.6rem;
  }
}`;
const shadowOptions = { "mode": "closed" };
let CodeScreenComponent = class CodeScreenComponent extends client_1.RWSViewComponent {
    constructor(clipboardService) {
        super();
        this.clipboardService = clipboardService;
        this.showLineNumbers = false;
        this.copyButton = true;
        this.componentId = '';
        this.showTime = false;
        this.renderedContent = '';
        this.loading = false;
        this.error = null;
        this.slottedContent = [];
        this.copied = false;
        this.dropdownOpen = false;
        this.lang = null;
        this.showPreview = false;
        this.previewVisible = false;
        this.codeGenerating = false;
        this.htmlContentForPreview = '';
        this.isFullscreen = false;
        this.isPopupMode = false;
        this.ended = false;
        this.activatePreview = false;
        this.isContentFromPassedContent = false;
        this.hasStartedStreaming = false;
        this.componentHeight = null; // Default height
        this.scrollContainer = null;
        this.handleDropdownOutsideClick = (event) => {
            var _a;
            const target = event.target;
            const dropdown = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.dropdown-container');
            if (dropdown && !dropdown.contains(target)) {
                this.dropdownOpen = false;
                document.removeEventListener('click', this.handleDropdownOutsideClick);
            }
        };
        this.handleToggleToCodeView = (event) => {
            this.previewVisible = false; // Przełącz na widok kodu
            event.stopPropagation();
        };
        this.handleClosePreview = (event) => {
            // Close the preview by setting previewVisible to false
            this.previewVisible = false;
            event.stopPropagation();
        };
        this.handleDownloadHtml = (event) => {
            // Handle download event for analytics or logging
            event.stopPropagation();
        };
        this.handleFullscreenChange = () => {
            const fullscreenElement = document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            this.isFullscreen = !!fullscreenElement;
        };
        this.handleOutsideClick = (event) => {
            var _a;
            const target = event.target;
            const codeViewer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.code-viewer');
            // Check if the click is outside the code viewer component
            if (codeViewer && !codeViewer.contains(target) && !this.contains(target)) {
                this.closePopup();
            }
        };
        this.handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                if (this.isFullscreen) {
                    this.exitFullscreen();
                }
                else if (this.isPopupMode) {
                    this.closePopup();
                }
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        this.resizeComponent();
        // Generate a unique ID if none provided
        if (!this.componentId) {
            this.componentId = voucher_code_generator_1.default.generate({ count: 1, length: 8 })[0].toLowerCase();
        }
        this.observeSlotChanges();
        this.addEventListener('toggle-to-code-view', this.handleToggleToCodeView);
        // Add event listener for close preview events from html-preview component
        this.addEventListener(events_1.appEvents.codeViewerClosePreview, this.handleClosePreview);
        // Add event listener for download events from html-preview component
        this.addEventListener(events_1.appEvents.codeViewerDownloadHtml, this.handleDownloadHtml);
        // Add fullscreen event listeners
        document.addEventListener('fullscreenchange', this.handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
        this.on('popup-toggle', (event) => {
            this.isPopupMode = event.detail.isPopupMode;
        });
        if (this.lang) {
            await this.renderMarkdown();
        }
        window.addEventListener('resize', () => { this.resizeComponent(); });
    }
    endedChanged(oldV, newV) {
        if (this.ended && this.lang === 'html') {
            this.previewVisible = true;
            this.updateHtmlPreview();
        }
    }
    codeGeneratingChanged(oldV, newV) {
        if (newV && !oldV) {
            // Starting code generation - clear content to start fresh
            this.clearContent();
            this.hasStartedStreaming = true;
        }
    }
    clearContent() {
        // Clear all existing content
        this.slottedContent = [];
        this.renderedContent = '';
        this.passedContent = '';
        this.htmlContentForPreview = '';
        this.previewVisible = false;
        this.isContentFromPassedContent = false;
        console.log('Content cleared');
    }
    resizeComponent() {
        var _a;
        if (!this.codeViewer)
            return;
        // Get the host element's computed height
        const hostElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.host;
        if (!hostElement)
            return;
        const hostHeight = hostElement.clientHeight;
        // Check if this is in share-preview mode
        if (hostElement.classList.contains('share-preview')) {
            // For share-preview, use actual host height but respect CSS max-height 700px constraint
            if (hostHeight > 0) {
                // Cap at 700px to match CSS max-height
                const constrainedHeight = Math.min(hostHeight, 700);
                this.codeViewer.style.height = `${constrainedHeight}px`;
                return;
            }
            // If no host height, don't set any height - let CSS handle it
            this.codeViewer.style.height = '';
            return;
        }
        // Always set code-viewer height to match host element for non-share-preview
        if (hostHeight > 0) {
            this.codeViewer.style.height = `${hostHeight}px`;
            return;
        }
        // If no explicit height is set on host, try to get from parent container
        const parentContainer = hostElement.closest('#chat__containerWrapper') || hostElement.parentElement;
        if (parentContainer) {
            const containerHeight = parentContainer.clientHeight;
            if (containerHeight > 0) {
                this.codeViewer.style.height = `${containerHeight}px`;
                return;
            }
        }
        // Fallback to default height for non-share-preview components
        this.codeViewer.style.height = '400px';
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('toggle-to-code-view', this.handleToggleToCodeView);
        // Remove event listener for close preview events
        this.removeEventListener(events_1.appEvents.codeViewerClosePreview, this.handleClosePreview);
        document.removeEventListener('click', this.handleDropdownOutsideClick);
        // Remove event listener for download events
        this.removeEventListener(events_1.appEvents.codeViewerDownloadHtml, this.handleDownloadHtml);
        // Remove fullscreen event listeners
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
        document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
        // Clean up popup event listeners
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscapeKey);
        window.removeEventListener('resize', () => { this.resizeComponent(); });
    }
    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
        if (this.dropdownOpen) {
            setTimeout(() => {
                document.addEventListener('click', this.handleDropdownOutsideClick);
            }, 100);
        }
        else {
            document.removeEventListener('click', this.handleDropdownOutsideClick);
        }
    }
    languageChanged(oldValue, newValue) {
        if (newValue && newValue !== oldValue) {
            this.lang = newValue;
            // Always determine showPreview internally based on language
            this.showPreview = (newValue === null || newValue === void 0 ? void 0 : newValue.toLowerCase()) === 'html';
            this.renderMarkdown();
        }
    }
    isPopupModeChanged(oldValue, newValue) {
        if (newValue) {
            if (newValue !== oldValue) {
                // Entering popup mode
            }
        }
        else {
            if (oldValue === true && newValue === false) {
            }
        }
    }
    slottedContentChanged() {
        // Only render if we don't have passedContent
        // When passedContent is set, rendering is handled by passedContentChanged
        if (!this.passedContent) {
            this.renderMarkdown();
        }
    }
    observeSlotChanges() {
        var _a;
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
        if (slot) {
            slot.addEventListener('slotchange', () => {
                // Only extract from slot if we don't have passedContent
                if (!this.passedContent) {
                    this.extractSlottedMarkdown();
                }
            });
            // Initial extraction only if no passedContent
            if (!this.passedContent) {
                this.extractSlottedMarkdown();
            }
        }
    }
    scrollToBottom() {
        if (!this.scrollContainer)
            return;
        if (this.scrollContainer) {
            // Scroll to bottom smoothly
            this.scrollContainer.scrollTo({
                top: this.scrollContainer.scrollHeight
            });
        }
    }
    extractSlottedMarkdown() {
        var _a;
        // Don't extract from slot if we have passedContent set
        // This prevents overwriting manually set slottedContent
        if (this.passedContent) {
            return;
        }
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot');
        if (slot) {
            const assignedNodes = slot.assignedNodes();
            this.slottedContent = assignedNodes;
            this.renderMarkdown();
        }
    }
    getMarkdownFromSlot() {
        if (!this.slottedContent || this.slottedContent.length === 0) {
            return '';
        }
        // Extract text content from slotted nodes
        let markdownContent = '';
        this.slottedContent.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                markdownContent += node.textContent || '';
            }
            else if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                // If it's a script tag with type="text/markdown", use its content
                if (element.tagName.toLowerCase() === 'script' &&
                    element.getAttribute('type') === 'text/markdown') {
                    markdownContent += element.textContent || '';
                }
                else {
                    // For HTML content, preserve the markup structure instead of extracting only text
                    // This ensures <style>, <script>, and other tags remain visible
                    if (this.lang && (this.lang.toLowerCase() === 'html' || this.lang.toLowerCase() === 'markup')) {
                        markdownContent += element.innerHTML || element.textContent || '';
                    }
                    else {
                        // For non-HTML content, use text content as before
                        markdownContent += element.textContent || '';
                    }
                }
            }
        });
        // Just trim the content, don't remove ``` - the parser handles this correctly
        const trimmedContent = markdownContent.trim();
        return trimmedContent;
    }
    passedContentChanged(oldV, newV) {
        if (newV) {
            this.previewVisible = false;
            // Set flag to indicate content is from passedContent
            this.isContentFromPassedContent = true;
            // Create a new text node with the passed content and set it as slotted content
            // This ensures that getMarkdownFromSlot() will return the correct content
            const textNode = document.createTextNode(newV);
            this.slottedContent = [textNode];
            // Re-render the markdown with the new content
            this.renderMarkdown();
            this.scrollToBottom();
        }
        else if (oldV && !newV) {
            // Content was cleared
            this.isContentFromPassedContent = false;
        }
    }
    activatePreviewChanged(oldValue, newValue) {
        if (newValue) {
            this.previewVisible = true;
        }
    }
    async renderMarkdown() {
        let rawContent = this.getMarkdownFromSlot();
        if (!rawContent) {
            this.renderedContent = '';
            return;
        }
        this.loading = true;
        this.error = null;
        if (!this.lang) {
            this.loading = false;
            return;
        }
        try {
            // Map common language aliases to Prism language names
            const languageMap = {
                'html': 'markup',
                'xml': 'markup',
                'svg': 'markup',
                'mathml': 'markup',
                'ssml': 'markup',
                'atom': 'markup',
                'rss': 'markup'
            };
            let language = this.lang || 'plaintext';
            const mappedLanguage = languageMap[language.toLowerCase()] || language;
            const validLanguage = Prism.languages[mappedLanguage] ? mappedLanguage : 'plaintext';
            // Create simple pre/code structure like before
            let codeElement = '';
            if (validLanguage !== 'plaintext' && Prism.languages[validLanguage]) {
                // Apply Prism highlighting
                try {
                    const highlighted = Prism.highlight(rawContent, Prism.languages[validLanguage], validLanguage);
                    const lineNumbersClass = this.showLineNumbers ? ' line-numbers' : '';
                    codeElement = `<pre class="language-${language}${lineNumbersClass}"><code class="language-${language}">${highlighted}</code></pre>`;
                }
                catch (e) {
                    console.warn(`Failed to highlight with Prism for ${validLanguage}`, e);
                    // For HTML/markup content, we should escape it to display as code, not render as HTML
                    const content = this.escapeHtml(rawContent);
                    const lineNumbersClass = this.showLineNumbers ? ' line-numbers' : '';
                    codeElement = `<pre class="language-${language}${lineNumbersClass}"><code class="language-${language}">${content}</code></pre>`;
                }
            }
            else {
                // Fallback for unsupported languages
                const lineNumbersClass = this.showLineNumbers ? ' line-numbers' : '';
                codeElement = `<pre class="language-plaintext${lineNumbersClass}"><code class="language-plaintext">${this.escapeHtml(rawContent)}</code></pre>`;
            }
            this.renderedContent = codeElement;
            // Update HTML preview if language is HTML
            this.updateHtmlPreview();
            // First ensure we show code view to get proper height calculation
            this.previewVisible = false;
            // Resize component after rendering to ensure proper height
            requestAnimationFrame(() => {
                var _a;
                this.resizeComponent();
                // Then switch to preview for HTML when showTime is true, after resize is complete
                if (this.showTime && ((_a = this.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'html') {
                    requestAnimationFrame(() => {
                        this.previewVisible = true;
                    });
                }
            });
        }
        catch (err) {
            console.error('Error rendering code:', err);
            this.error = 'Failed to render code content';
            this.renderedContent = '';
        }
        finally {
            this.loading = false;
        }
    }
    updateRenderer(text, chunked = true) {
        var _a;
        // Simply append new text chunks to existing content - no special processing
        if (text) {
            // If this is the first chunk of streaming and we have existing content,
            // it means we're starting a new code block - clear everything
            if (chunked && !this.hasStartedStreaming && this.slottedContent.length > 0) {
                this.clearContent();
                // console.log(this.previewVisible);
            }
            // Get current content from slotted nodes
            let currentContent = '';
            if (!chunked) {
                // Clear all content when starting fresh (non-chunked mode)
                this.slottedContent = [];
                // Also clear rendered content to start fresh
                this.renderedContent = '';
            }
            this.slottedContent.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    currentContent += node.textContent || '';
                }
                else if (node.nodeType === Node.ELEMENT_NODE) {
                    const element = node;
                    if (element.tagName.toLowerCase() === 'script' &&
                        element.getAttribute('type') === 'text/markdown') {
                        currentContent += element.textContent || '';
                    }
                    else {
                        // For HTML content, preserve the markup structure instead of extracting only text
                        // This ensures <style>, <script>, and other tags remain visible during streaming updates
                        if (this.lang && (this.lang.toLowerCase() === 'html' || this.lang.toLowerCase() === 'markup')) {
                            currentContent += element.innerHTML || element.textContent || '';
                        }
                        else {
                            currentContent += element.textContent || '';
                        }
                    }
                }
            });
            // Simply append the new text chunk - no processing needed
            // The parser has already handled the code block detection and we're just
            // receiving raw content that should be displayed
            const updatedContent = currentContent + text;
            // Create a new text node with the combined content
            const textNode = document.createTextNode(updatedContent);
            this.slottedContent = [textNode];
            // Re-render the markdown with the updated content
            this.renderMarkdown();
            // Update HTML preview if in preview mode
            if (this.showPreview && this.previewVisible && ((_a = this.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'html') {
                this.updateHtmlPreview();
            }
            // Auto-scroll to show the new content
            this.scrollToBottom();
        }
    }
    escapeHtml(str) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
    getCopyText() {
        const markdownContent = this.getMarkdownFromSlot();
        // Extract code blocks from markdown - capture everything after the language identifier
        const codeBlockRegex = /```(?:\w+)?\n?/g;
        const matches = [...markdownContent.matchAll(codeBlockRegex)];
        if (matches && matches.length > 0) {
            const lastMatch = matches[matches.length - 1];
            return markdownContent.replace(lastMatch[0], '');
        }
        return markdownContent;
    }
    async copyToClipboard() {
        const result = await this.clipboardService.copyText(this.getCopyText());
        this.copied = true;
        if (!result.success) {
            this.copied = false;
            console.error('Failed to copy code:', result.message);
        }
    }
    refresh() {
        this.renderMarkdown();
    }
    getRawContent() {
        return this.getMarkdownFromSlot();
    }
    updateHtmlPreview() {
        var _a;
        if (this.showPreview && ((_a = this.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'html') {
            // Set the raw HTML content for the preview component
            this.htmlContentForPreview = this.getRawContent();
        }
    }
    togglePreview() {
        this.previewVisible = !this.previewVisible;
    }
    startCodeGeneration() {
        this.showPreview = false;
        this.previewVisible = false;
        this.activatePreview = false;
        this.codeGenerating = true;
    }
    stopCodeGeneration() {
        var _a;
        this.codeGenerating = false;
        if (((_a = this.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'html') {
            this.showPreview = true;
            this.activatePreview = true;
            this.previewVisible = true;
        }
    }
    isPreviewToggleAvailable() {
        return !this.codeGenerating && this.showPreview;
    }
    // Fullscreen functionality
    toggleFullscreen() {
        if (this.isFullscreen) {
            this.exitFullscreen();
        }
        else {
            this.enterFullscreen();
        }
    }
    async enterFullscreen() {
        var _a;
        const codeViewer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.code-viewer');
        if (!codeViewer)
            return;
        try {
            if (codeViewer.requestFullscreen) {
                await codeViewer.requestFullscreen();
            }
            else if (codeViewer.webkitRequestFullscreen) {
                await codeViewer.webkitRequestFullscreen();
            }
            else if (codeViewer.mozRequestFullScreen) {
                await codeViewer.mozRequestFullScreen();
            }
            else if (codeViewer.msRequestFullscreen) {
                await codeViewer.msRequestFullscreen();
            }
        }
        catch (err) {
            console.error('Failed to enter fullscreen:', err);
        }
    }
    async exitFullscreen() {
        try {
            if (document.exitFullscreen) {
                await document.exitFullscreen();
            }
            else if (document.webkitExitFullscreen) {
                await document.webkitExitFullscreen();
            }
            else if (document.mozCancelFullScreen) {
                await document.mozCancelFullScreen();
            }
            else if (document.msExitFullscreen) {
                await document.msExitFullscreen();
            }
        }
        catch (err) {
            console.error('Failed to exit fullscreen:', err);
        }
    }
    // Popup functionality
    togglePopup() {
        if (this.isPopupMode) {
            this.closePopup();
        }
        else {
            this.isPopupMode = true;
            // Add event listeners with a slight delay to prevent immediate triggering
            setTimeout(() => {
                // document.addEventListener('click', this.handleOutsideClick);
                document.addEventListener('keydown', this.handleEscapeKey);
            }, 100);
        }
    }
    // Close method for the close button
    close() {
        // Find the closest chat-thread-component and the corresponding code-viewer
        this.updateCodeViewerState();
        // Keep existing close behavior
        if (this.isPopupMode) {
            this.closePopup();
        }
        else if (this.isFullscreen) {
            this.exitFullscreen();
        }
        else {
            // Emit a custom close event that parent components can listen to
            this.dispatchEvent(new CustomEvent('code:close', {
                bubbles: true,
                composed: true,
                detail: { componentId: this.componentId }
            }));
        }
    }
    updateCodeViewerState() {
        var _a, _b, _c, _d;
        // Find the closest chat-thread-component element
        const chatThreadComponent = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.host.parentElement) === null || _b === void 0 ? void 0 : _b.closest('#chat__containerWrapper')) === null || _c === void 0 ? void 0 : _c.querySelector('chat-thread-component');
        if (chatThreadComponent) {
            // Find the specific code-viewer with matching componentId
            const codeViewers = (_d = chatThreadComponent.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelectorAll('code-viewer');
            codeViewers === null || codeViewers === void 0 ? void 0 : codeViewers.forEach(viewer => {
                const viewerId = viewer.getAttribute('componentId');
                if (viewerId === this.componentId) {
                    // Update the code-viewer to show "show code" state
                    viewer.setCodeHidden();
                }
            });
        }
        // Also dispatch an event that the code-viewer can listen to
        this.dispatchEvent(new CustomEvent('code-screen:closed', {
            detail: { componentId: this.componentId },
            bubbles: true,
            composed: true
        }));
    }
    closePopup() {
        this.isPopupMode = false;
        // document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscapeKey);
    }
};
exports.CodeScreenComponent = CodeScreenComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "showLineNumbers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "copyButton", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CodeScreenComponent.prototype, "language", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CodeScreenComponent.prototype, "componentId", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "showTime", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CodeScreenComponent.prototype, "passedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CodeScreenComponent.prototype, "renderedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CodeScreenComponent.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CodeScreenComponent.prototype, "slottedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "copied", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "dropdownOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], CodeScreenComponent.prototype, "lang", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "showPreview", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "previewVisible", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "codeGenerating", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CodeScreenComponent.prototype, "htmlContentForPreview", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "isFullscreen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "isPopupMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "ended", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "activatePreview", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CodeScreenComponent.prototype, "isContentFromPassedContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CodeScreenComponent.prototype, "componentHeight", void 0);
exports.CodeScreenComponent = CodeScreenComponent = __decorate([
    (0, client_1.RWSView)('code-screen', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(ClipboardService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof ClipboardService_1.ClipboardServiceInstance !== "undefined" && ClipboardService_1.ClipboardServiceInstance) === "function" ? _a : Object])
], CodeScreenComponent);
CodeScreenComponent.defineComponent();
